import axios from './_nestAxios'

export const self = {
  validarCompaniaProducto: () => axios.post('/companias/self/validar-compania-producto'),
  getCompania: () => axios.get(`/companias/self`),
  actualizarCompania: data => axios.put(`/companias/self`, data)
}

export const getCompanias_Select = () => axios.get('/companias', { params: { tipoConsulta: 'select' } })
export const obtenerTodoMasSedesMasSeries = () =>
  axios.get('/companias', { params: { tipoConsulta: 'mas-sedes-mas-series' } })

export const obtenerCompaniaConfiguracion = () => axios.get('/companias/compania-configuracion')

export const insertarActualizarCompaniaLogoExterno = (data) => axios.post('/companias/actualizar-compania-logo-externo', data)
export const insertarActualizarCompaniaLogoImpresion = (data) => axios.post('/companias/actualizar-compania-logo-impresion', data)

export const insertarActualizarCompaniaConfiguracion = data => axios.post('/companias/compania-configuracion', data)

export const eliminarCompaniaLogoExterno = () => axios.delete('/companias/eliminar-compania-logo-externo')
export const eliminarCompaniaLogoImpresion = () => axios.delete('/companias/eliminar-compania-logo-impresion')